import React from "react";
import { useParams } from "react-router-dom";
import Theme404 from "../../layout/404";

import city_list from "./city.list";
import city_edit from "./city.edit";

/**
 *   Create index file for City
 */

export default function List_city() {
  let useParam = {} as any;
  useParam = useParams();
  let Param = useParam.slug || "list";

  let ActualPage: any;
  switch (Param) {
    case "list":
      ActualPage = city_list;
      break;

    case "edit":
      ActualPage = city_edit;
      break;

    case "new":
      ActualPage = city_edit;
      break;

    default:
      ActualPage = Theme404;
      break;
  }

  return <>{<ActualPage />}</>;
}

